import axios from "axios";

const baseLoginClient = axios.create({
  baseURL: process.env.REACT_APP_R_BASECLIEN, // 서버
  timeout: 30 * 1000,
});

baseLoginClient.interceptors.request.use(function (config) {
  return config;
});

baseLoginClient.interceptors.response.use(
  function (response) {
    return response;
  },

  function (error) {
    return Promise.reject(error);
  }
);

export default baseLoginClient;
